module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mixed_mobile1-d08a8ab5eb3aecaa2519d8431a882e03.jpg";